import api from "./apiClient.js";

const endpoint = "pce";

export const getAllPces = () => {
	return api.get(endpoint);
};

export const getAllPcesShort = () => {
	return api.get(endpoint + "/icons");
};

export const getPceById = (id) => {
	return api.get(endpoint + "/" + id);
};

export const createPce = (whatToDo) => {
	return api.post(endpoint, whatToDo);
};

export const updatePce = (whatToDo) => {
	return api.put(endpoint + "/" + whatToDo.id, whatToDo);
};

export const deletePce = (id) => {
	return api.delete(endpoint + "/" + id);
};
